import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import XtBtntxt from "@/components/Xt/BtnTxt";
import { waitRes } from "@/utils/axios";
import { post_enterpriseApplyGetApplyId } from "@/api/xt-user";
interface P0Props extends BaseCompProps {
  attr?: any;
  onStart?(id: string): void;
}
const { useTranslation } = Hooks;
const P0: React.FC<P0Props> = ({ className, onStart }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  const [loading, setLoading] = useState(false);

  /** method */
  const handleStart = async () => {
    setLoading(true);
    const { data, err } = await waitRes(post_enterpriseApplyGetApplyId);
    setLoading(false);
    if (!err) {
      onStart && onStart(data.enterpriseApplyId);
    }
  };
  return (
    <div className={cx(styles["page-account-enterprise-p0"], className)}>
      <div className={styles["iHead"]}>{t("ent.startTip0")}</div>
      <div className={styles["iBody"]}>
        <div>{t("ent.startTip1")}</div>
        <div>{t("ent.startTip2")}</div>
        <div>{t("ent.startTip3")}</div>
        <div>{t("ent.startTip4")}</div>
        <div>{t("ent.startTip5")}</div>
        <div>{t("ent.startTip6")}</div>
        <div>{t("ent.startTip7")}</div>
        <div>{t("ent.startTip8")}</div>
      </div>
      <div className={styles["page-account-enterprise--btns"]}>
        <XtBtntxt className={styles["btntxt-p0"]} onClick={handleStart} disabled={loading}>
          {t("ent.startAuth")}
        </XtBtntxt>
      </div>
    </div>
  );
};
export default observer(P0);
